<template>
  <div class="user-cases">
    <el-row>
      <el-col :span="24">
        <h1 class="user_title">用户案例场景演示</h1>
      </el-col>
    </el-row>
    <el-row class="carousel">
      <!-- 左箭头图片 -->
      <img
        class="leftArrow"
        src="../../assets/home/leftArrow.png"
        alt="left arrow"
        @click="prevImage"
        style="
          cursor: pointer;
          position: absolute;
          left: 10px;
          z-index: 10;
          width: 60px;
          height: 60px;
        "
      />
      <div class="carousel-box" v-show="cases.length > 0">
         <!-- :style="{ transform: `translateX(-${(currentIndex + 1) * 50}%)` }" -->
        <div 
          class="carousel-container" 
                    :style="{ transform: `translateX(calc(-${(currentIndex + 1) * 50}% - ${(currentIndex - 1) * 40}px + 25% - 80px))` }"
          @transitionend="onTransitionEnd"
        >
          <!-- 左侧隐藏部分 -->
          <div class="carousel-item side-image" v-if="cases.length > 0">
            <img
              :src="cases[lastIndex].img ? cases[lastIndex].img.split(',')[0] : ''"
              class="image"
            />
          </div>
          <!-- 正常显示部分 -->
          <div 
            v-for="(item, index) in cases" 
            :key="item.id"
            class="carousel-item"
            :class="{ 'main-image': index === currentIndex, 'side-image': index !== currentIndex }"
          >
            <img
              :src="item.img ? item.img.split(',')[0] : ''"
              class="image"
            />
            <div v-if="index === currentIndex" class="main-image-overlay">
              <div class="main-title">
                {{ 
                  item.title
                    ? item.title.replace(
                        /(\(|（)[^）)）]*(\)|）)/g,
                        "",
                      )
                    : ""
                }}
              </div>

              <div class="main-subtitle">
                用户痛点
                <span style="margin: 0 8px">|</span>
                {{ item.refine }}
              </div>
              <p class="main-content">{{ item.effect }}</p>
              <button
                class="main-button"
                @click="viewDetails(item.id)"
              >
                了解详情 >
              </button>
            </div>
          </div>
          <!-- 右侧隐藏部分 -->
          <div class="carousel-item side-image" v-if="cases.length > 0">
            <img
              :src="cases[0].img ? cases[0].img.split(',')[0] : ''"
              class="image"
            />
          </div>
        </div>
      </div>
      <!-- 右箭头图片 -->
      <img
        class="rightArrow"
        src="../../assets/home/rightArrow.png"
        alt="right arrow"
        @click="nextImage"
        style="
          cursor: pointer;
          position: absolute;
          right: 10px;
          z-index: 10;
          width: 60px;
          height: 60px;
        "
      />
    </el-row>
    <el-row>
      <el-col :span="24" class="view-more">
        <a href="/all_user_cases?source=all_user_cases&navUserCaseType=1">查看更多用户案例 ></a>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { caseListByType } from "@/api/dataManeger.js";
import { IMG_BASE_URL } from "@/utils/index.js";
export default {
  name: "UserCases",
  data() {
    return {
      cases: [],
      currentIndex: 0,
      isTransitioning: false,
    };
  },
  computed: {
    prevIndex() {
      return (this.currentIndex - 1 + this.cases.length) % this.cases.length;
    },
    IMG_BASE_URL() {
      return IMG_BASE_URL;
    },
    nextIndex() {
      return (this.currentIndex + 1) % this.cases.length;
    },
    lastIndex() {
      return this.cases.length - 1;
    },
  },
  methods: {
    prevImage() {
      if (this.isTransitioning) return;
      this.isTransitioning = true;
      this.currentIndex--;
    },
    getCases() {
      caseListByType({ type: this.activeCategoryId }).then((res) => {
        if (res) {
          this.cases = res.result.filter(
            (item) => item.img && item.img.trim() !== "",
          );
        }
      });
    },
    nextImage() {
      if (this.isTransitioning) return;
      this.isTransitioning = true;
      this.currentIndex++;
    },
    onTransitionEnd() {
      this.isTransitioning = false;
      // 当到达克隆的第一个元素区域时，跳转到真实的最后一个元素区域
      if (this.currentIndex < 0) {
        this.currentIndex = this.cases.length - 1;
        // 强制更新样式以避免过渡动画
        this.$nextTick(() => {
          const carouselGroup = this.$el.querySelector('.carousel-container');
          carouselGroup.style.transition = 'none';
          carouselGroup.offsetHeight; // 触发重排
          carouselGroup.style.transition = '';
        });
      }
      // 当到达克隆的最后一个元素区域时，跳转到真实第一个元素区域
      else if (this.currentIndex >= this.cases.length) {
        this.currentIndex = 0;
        // 强制更新样式以避免过渡动画
        this.$nextTick(() => {
          const carouselGroup = this.$el.querySelector('.carousel-container');
          carouselGroup.style.transition = 'none';
          carouselGroup.offsetHeight; // 触发重排
          carouselGroup.style.transition = '';
        });
      }
    },
    viewDetails(id) {
      const caseItem = this.cases.find((item) => item.id === id);
      localStorage.setItem("activeNav", "userCase");
      if (caseItem) {
        this.$router.push({
          path: "/user_case_detail",
          query: {
            source: caseItem.route,
            id: id,
            userCaseType: this.activeCategoryId,
          },
        });
      }
    },
  },
  watch: {
    "$route.fullPath": {
      immediate: true,
      handler() {
        this.currentIndex = 0;
      },
    },
  },
  mounted() {
    this.getCases();
  },
};
</script>
<style lang="scss" scoped>
.user_title {
  margin: 80px 0 30px;
  opacity: 1;
  color: #1e242a;
}

.user-cases {
  width: 100%;
  margin: 0 auto;
  text-align: center;
  background: #fbfbfb;
}

.carousel {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.carousel-box {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 57vh;
  overflow: hidden;
  position: relative;
}

.carousel-container {
  display: flex;
  align-items: center;
  height: 100%;
  transition: transform 0.5s ease;
  gap: 40px;
}

.carousel-item {
  flex-shrink: 0;
  height: 100%;
  position: relative;
  overflow: hidden;
  border-radius: 8px;
}

.side-image {
  width: 50%;
}

.side-image img {
  width: 200%;
  height: 100%;
  object-fit: cover;
  object-position: right;
}

.carousel-item:nth-child(1) img {
  object-position: right;
}

.carousel-item:nth-child(3) img {
  object-position: left;
  /* 显示左边部分 */
}

.main-image {
  width: 50%;
  /* 主图片占据中间部分 */
  position: relative;
  display: flex;
  justify-content: center;
}

.main-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 渐变遮罩 */
.carousel-item::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 8px;
  background: linear-gradient(
    90deg,
    rgba(30, 36, 42, 0.6) 0%,
    rgba(30, 36, 42, 0.1) 100%
  );
}

.main-image-overlay {
  position: absolute;
  bottom: 40px;
  left: 40px;
  color: #fff;
  display: flex;
  flex-direction: column;
  z-index: 2;
  text-align: left;
  top: 0px;
  left: 0px;
  width: 480px;
  margin-left: 120px;
  margin-top: 15%;
}

.main-title {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 12px;
}

.main-subtitle {
  font-size: 14px;
  margin-bottom: 16px;
  opacity: 0.8;
  color: #fff;
  font-weight: normal;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.main-content {
  font-size: 16px;
  margin-bottom: 40px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
}

.main-button {
  width: 120px;
  height: 40px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.4);
  color: #fff;
  font-size: 14px;
  cursor: pointer;
  text-align: center;
  transition: all 0.3s;
}

.main-button:hover {
  border-color: #0f6bf6;
  color: #0f6bf6;
}

.view-more {
  margin: 40px 0px 80px;
}

.view-more a {
  text-decoration: none;
  color: #1e242a;
  font-size: 16px;
}

.leftArrow {
  left: 11% !important;
}
.rightArrow {
  right: 11% !important;
}
</style>